import React from 'react';
import type { LoadMoreTriggerProps } from '../types.js';

/**
 * Load more trigger component
 * Memoized component for infinite scroll trigger
 */
export const LoadMoreTrigger = React.forwardRef<HTMLDivElement, Omit<LoadMoreTriggerProps, 'ref'>>(
  ({ hasMoreChats, isLoadingMoreChats }, ref) => {
    if (!hasMoreChats) return null;

    return (
      <div 
        ref={ref}
        className="flex justify-center py-4 mt-4"
      >
        {isLoadingMoreChats && (
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <svg className="w-3 h-3 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Loading more chats...
          </div>
        )}
      </div>
    );
  }
);

LoadMoreTrigger.displayName = 'LoadMoreTrigger';

export default React.memo(LoadMoreTrigger);
